
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.5 5.5h57v53h-57zM10.69.5v10M20.35.5v10M30.02.5v10M39.69.5v10M49.35.5v10M2.14 19.45h55.72"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M30 28.06l3.55 7.2 7.95 1.16-5.75 5.6 1.36 7.92L30 46.2l-7.11 3.74 1.36-7.92-5.75-5.6 7.95-1.16 3.55-7.2z"}})])
          )
        }
      }
    